<template>
  <div class="center-cell">
    <message-text-icon
      v-if="props.row.comment || props.row.has_comments"
      :title="'Order Comments'"
      class="clickable"
      v-bind:data-id="props.row.ID || props.row.order_id"
      @click="handleClick"
      :size="17"/>
      <span v-else>-</span>
  </div>
</template>


<script>
  import { MessageTextIcon } from '../../icons.js';

  export default {
    name: 'AsComments',
    props: ['props'],
    components: {
      MessageTextIcon
    },
    methods: {
      handleClick() {
        if (this.props.onClickFunction) {
          this.props.onClickFunction(this.props.showCommentsComponent);
        }
      }
    }
  };
</script>
